enum QuestionResult {
    CORRECT = "correct",
    INCORRECT = "incorrect",
    PARTIAL = "partial",
}

export default QuestionResult;
